<svelte:options accessors={true}/>
<script>import { seriesStore } from "./stores";
import RadialProgressBar from "./RadialProgressBar.svelte";
import LinearProgressBar from "./LinearProgressBar.svelte";
import CustomShapeProgressBar from "./CustomShapeProgressBar.svelte";
export let series = [];
export let style = "default";
export let thickness = style == "radial" || style == "semicircle" ? 5 : null;
export let stackSeries = true;
export let margin = 0;
export let valueLabel = "";
export let width = "100%";
export let colors = [
  "#FFC107",
  "#4CAF50",
  "#03A9F4"
];
export let thresholds = [];
if (width == "auto")
  width = "100%";
let actWidth = 0;
const store = seriesStore(series, {
  valueLabel,
  colors,
  thresholds,
  stackSeries,
  thickness,
  margin
});
$:
  store.updateSeries(series);
$: {
  if (valueLabel != null)
    store.updateLabel(valueLabel);
}
export function updatePerc(perc, seriesIdx = 0) {
  store.updatePerc(perc, seriesIdx);
}
export function updateSeries(_series) {
  series = _series;
}
</script>

<div bind:clientWidth={actWidth} class="pb_cnt" style="width:{typeof width == 'string' ? width : width + 'px'}">
	{#if style == 'radial' || style == 'semicircle'}
		<RadialProgressBar
			{...$$props}
			{store}
			{colors}
			{thresholds}
			{actWidth}
			{style}>
			<slot></slot>
		</RadialProgressBar>
	{:else if style == 'custom'}
		<CustomShapeProgressBar
			{...$$props}
			{store}
			{actWidth}
			{style}
			/>
	{:else}
		<LinearProgressBar
			{...$$props}
			{store}
			{actWidth}
			/>
	{/if}
</div>